import type {PropsWithChildren} from "react";
import {Feature} from "app/gql/graphqlSchema";
import {useEnabledFeatures} from "app/employee/state/bootstrapEmployee/selectors";
import {NotFoundPage} from "app/employee/page/NotFoundPage";

interface Props {
  feature: Feature;
}

export const RoutingGuard = ({feature, children}: PropsWithChildren<Props>) => {
  const checkFeature = useEnabledFeatures();
  const featureEnabled = checkFeature(feature);

  if (featureEnabled) {
    return <>{children}</>;
  } else {
    return <NotFoundPage />;
  }
};
